import CustomSwitch from "@UI/CustomSwitch"
import { Button } from "antd"
import './styles.css'
import { useArrearsOption } from "./hooks/useArrearsOption"
import ArrearsModal from "./components/ArrearsModal/ArrearsModal"
import EditIcon from "@assets/icons/EditIcon"

const ArreasOption = () => {
  const { isOpenModal, chargeDetail, lateFeeData, currencySymbol, handleSwitchArrearsOption, handleOpenCloseModal } = useArrearsOption()

  return (
    <div className="arrears-options">
      <div>
        <div className="arrears-options-title">
          <strong>Mora</strong>
          <CustomSwitch
            checked={chargeDetail.late_fee.metadata?.enabled}
            onChange={(value) => handleSwitchArrearsOption({ value })}
          />
        </div>
        {
          chargeDetail.late_fee.metadata ? <div>
            <span>{lateFeeData?.name}</span>
            <p>{lateFeeData?.code === 'percentage' ? `${chargeDetail.late_fee.metadata.value?.toFixed(2)}%` : `${currencySymbol} ${chargeDetail.late_fee.metadata.value?.toFixed(2) ?? '---'}`}</p>
          </div>
            : <p>Aún no se ha definido la mora</p>
        }
      </div>

      {
        !chargeDetail.late_fee.metadata ? <Button onClick={() => handleOpenCloseModal({ isOpenModal: true })} className="btn-standard-white" shape="round" style={{ width: '92px' }}>
          DEFINIR
        </Button> :
          <Button
            onClick={() => handleOpenCloseModal({ isOpenModal: true })}
            className="btn-standard-transparent"
            style={{ width: '40px', height: '40px', border: '1px solid #232C4A', borderRadius: '50%' }}
            icon={<EditIcon color="#232C4A" width="20px" height="20px" />}
          />}
      <ArrearsModal
        isOpenModal={isOpenModal}
        handleOpenCloseModal={handleOpenCloseModal}
      />
    </div>
  )
}

export default ArreasOption
